import { Component, ViewChild } from '@angular/core';
import { ResumeSendComponent } from '@app/components/resume-send-modal/resume-send/resume-send.component';
import { GenericComponent } from '@app/helpers/generic-component';
import { status_code } from 'functions/src/help/status-query';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends GenericComponent  {

  @ViewChild('resumeSend') resumeSendComponent: ResumeSendComponent;

  public selectedJob: any = {};
  public currentTagsSelected = 0;


  institutionSelected: any;


  constructor() {
    super();
  }
     

  setResumeSendApply(event, institution) {

    event.preventDefault();
    this.institutionSelected = institution;
    this.resumeSendComponent.setResumeSendApply(institution._id, institution.institutionName, JSON.parse(institution.institutionAddressList) as [], false);
  }

  eventModalResumeSend(event: any) {
    switch (event.action) {
      /*case "clear_bulk_options_event":
        this.search(false);
        break;*/

      case "update_search":
        //this.search(false);
        if (this.institutionSelected) { this.institutionSelected.resumeSent = 1; }
        this.scriptService.initPopover();
        this.scriptService.initCustomDisabledEvents();
        break;
    }
  }

  eventSendResume(e: { _idInstitution: number, employerName: string, employerAddress3: string }) {
    this.resumeSendComponent.setResumeSendApply(e._idInstitution, e.employerName, [e.employerAddress3], false)
  }
}

